import { ValidatorFn, Validators } from '@angular/forms';
import { DownloadType } from '../../../dto/enum/download-type.enum';
import { IFormProvider } from '../../form.provider';
import { USERNAME_REGEXP } from '../../../../../validation/const';
import { Injectable } from '@angular/core';
import {
  EMPTY,
  INSTAGRAM_HOST,
  MENTION_SYMBOL,
} from '../../../../../util/const';

@Injectable({
  providedIn: 'root',
})
export class AvatarFormProvider implements IFormProvider {
  public getErrorTip = (): string =>
    $localize`:@@download-form-avatar-input-error-tip:Please, enter correct username or Instagram link`;
  public getPlaceholder = (): string =>
    $localize`:@@download-form-avatar-input-placeholder:Username or Instagram link`;
  public getType = (): DownloadType => DownloadType.AVATAR;
  public getValidators = (): ValidatorFn[] => [
    Validators.pattern(USERNAME_REGEXP),
  ];

  public getOnInput(): (event: Event) => string {
    return (event: Event): string => {
      const htmlInputElement: HTMLInputElement = <HTMLInputElement>event.target;
      let value: string = htmlInputElement.value?.trim()?.toLowerCase();
      if (value.startsWith(MENTION_SYMBOL)) {
        value = value.substring(1);
      }
      if (value.includes(INSTAGRAM_HOST)) {
        const urlParts: string[] = value.split('/');
        value = urlParts[urlParts.length - 1] ?? EMPTY;
      }
      return value;
    };
  }
}
